/* eslint-env node */

export default typeof window !== 'undefined' ? window.debug : require('de' + 'bug'); // This hack prevents Browserify to bundle debug
